import { initializeFosse } from './client'

initializeFosse().catch(err => {
  throw err
})
